export const maskSensitiveText = (text: string): string =>
  '•'.repeat(text.length);
